var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16C27.5 16.1326 27.4473 16.2598 27.3536 16.3536C27.2598 16.4473 27.1326 16.5 27 16.5H16.5V27C16.5 27.1326 16.4473 27.2598 16.3536 27.3536C16.2598 27.4473 16.1326 27.5 16 27.5C15.8674 27.5 15.7402 27.4473 15.6464 27.3536C15.5527 27.2598 15.5 27.1326 15.5 27V16.5H5C4.86739 16.5 4.74021 16.4473 4.64645 16.3536C4.55268 16.2598 4.5 16.1326 4.5 16C4.5 15.8674 4.55268 15.7402 4.64645 15.6464C4.74021 15.5527 4.86739 15.5 5 15.5H15.5V5C15.5 4.86739 15.5527 4.74021 15.6464 4.64645C15.7402 4.55268 15.8674 4.5 16 4.5C16.1326 4.5 16.2598 4.55268 16.3536 4.64645C16.4473 4.74021 16.5 4.86739 16.5 5V15.5H27C27.1326 15.5 27.2598 15.5527 27.3536 15.6464C27.4473 15.7402 27.5 15.8674 27.5 16Z",
    fill: "var(--text-color, #BDBFBF)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusThin);
export default __webpack_public_path__ + "static/media/plus-thin.194e4e13fc9bfa9ef0de3c44ba7f6e22.svg";
export { ForwardRef as ReactComponent };